'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var g2 = require('@antv/g2');

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return {
          value: void 0,
          done: !0
        };
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable || "" === iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    throw new TypeError(typeof iterable + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var usePagination = function usePagination(_ref) {
  var total = _ref.total,
    perPage = _ref.perPage;
  var _useState = react.useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    page = _useState2[0],
    setPage = _useState2[1];
  var canGoNext = react.useMemo(function () {
    if (total === 0) {
      return false;
    }
    var pages = Math.ceil(total / perPage);
    if (page !== pages) {
      return true;
    }
    return false;
  }, [page, total, perPage]);
  var canGoPrev = react.useMemo(function () {
    return page !== 1;
  }, [page]);
  var goNext = function goNext() {
    if (!canGoNext) {
      return;
    }
    var newPage = page + 1;
    setPage(newPage);
  };
  var goPrev = function goPrev() {
    if (!canGoPrev) {
      return;
    }
    var newPage = page - 1;
    setPage(newPage);
  };
  return {
    goPrev: goPrev,
    goNext: goNext,
    canGoNext: canGoNext,
    canGoPrev: canGoPrev,
    page: page,
    setPage: setPage
  };
};

var mmtTheme = {
  // Base
  white: '#ffffff',
  colorPrimary: '#2E90FA',
  borderColor: '#EAECF0',
  // Gray
  gray50: '#D2D6DB',
  // Base Gray
  baseGray20: '#f5f5f5',
  baseGray30: '#F3F4F6',
  baseGray40: '#E5E7EB',
  baseGray50: '#D2D6DB',
  baseGray60: '#9DA4AE',
  baseGray70: '#6C737F',
  baseGray80: '#4D5761',
  baseGray90: '#384250',
  baseGray100: '#2B3644',
  baseGray110: '#1F2A37',
  // Primary
  colorPrimary1: '#F5FAFF',
  colorPrimary2: '#EFF8FF',
  colorPrimary3: '#D1E9FF',
  colorPrimary4: '#B2DDFF',
  colorPrimary5: '#84CAFF',
  colorPrimary6: '#53B1FD',
  colorPrimary7: '#2E90FA',
  colorPrimary8: '#1570EF',
  colorPrimary9: '#175CD3',
  colorPrimary10: '#1849A9',
  // Success
  success1: '#F6FEF9',
  success2: '#ECFDF3',
  success3: '#D7FBE5',
  success4: '#B0F3CB',
  success5: '#6AD99E',
  success6: '#32D583',
  success7: '#12B76A',
  success8: '#039855',
  success9: '#05603A',
  success10: '#054F31',
  // Warning
  warning1: '#FFFCF5',
  warning2: '#FFFAEB',
  warning3: '#FEF0C7',
  warning4: '#FEDF89',
  warning5: '#FEC84B',
  warning6: '#FDB022',
  warning7: '#F79009',
  warning8: '#DC6803',
  warning9: '#B54708',
  warning10: '#93370D',
  // Error
  error1: '#FFFBFA',
  error2: '#FEF3F2',
  error3: '#FEE4E2',
  error4: '#FECDCA',
  error5: '#FDA29B',
  error6: '#F97066',
  error7: '#F04438',
  error8: '#D92D20',
  error9: '#B42318',
  error10: '#912018',
  // Red
  red1: '#FFF1F0',
  red2: '#FFCCC7',
  red3: '#FFA39E',
  red4: '#FF7875',
  red5: '#FF4D4F',
  red6: '#F5222D',
  red7: '#CF1322',
  red8: '#A8071A',
  red9: '#820014',
  red10: '#5C0011',
  // Volcano
  volcano1: '#FFF2E8',
  volcano2: '#FFD8BF',
  volcano3: '#FFBB96',
  volcano4: '#FF9C6E',
  volcano5: '#FF7A45',
  volcano6: '#FA541C',
  volcano7: '#D4380D',
  volcano8: '#AD2102',
  volcano9: '#871400',
  volcano10: '#610B00',
  // Orange
  orange1: '#FFF7E6',
  orange2: '#FFE7BA',
  orange3: '#FFD591',
  orange4: '#FFC069',
  orange5: '#FFA940',
  orange6: '#FA8C16',
  orange7: '#D46B08',
  orange8: '#AD4E00',
  orange9: '#873800',
  orange10: '#612500',
  // Gold
  gold1: '#FFFBE6',
  gold2: '#FFF1B8',
  gold3: '#FFE58F',
  gold4: '#FFD666',
  gold5: '#FFC53D',
  gold6: '#FAAD14',
  gold7: '#D48806',
  gold8: '#AD6800',
  gold9: '#874D00',
  gold10: '#613400',
  // Yellow
  yellow1: '#feffe6',
  yellow2: '#ffffb8',
  yellow3: '#fffb8f',
  yellow4: '#fff566',
  yellow5: '#ffec3d',
  yellow6: '#fadb14',
  yellow7: '#d4b106',
  yellow8: '#ad8b00',
  yellow9: '#876800',
  yellow10: '#614700',
  // Lime
  lime1: '#FCFFE6',
  lime2: '#F4FFB8',
  lime3: '#EAFF8F',
  lime4: '#D3F261',
  lime5: '#BAE637',
  lime6: '#A0D911',
  lime7: '#7CB305',
  lime8: '#5B8C00',
  lime9: '#3F6600',
  lime10: '#254000',
  // Green
  green1: '#F6FFED',
  green2: '#D9F7BE',
  green3: '#B7EB8F',
  green4: '#95DE64',
  green5: '#73D13D',
  green6: '#52C41A',
  green7: '#389E0D',
  green8: '#237804',
  green9: '#135200',
  green10: '#092B00',
  // Cyan
  cyan1: '#E6FFFB',
  cyan2: '#B5F5EC',
  cyan3: '#87E8DE',
  cyan4: '#5CDBD3',
  cyan5: '#36CFC9',
  cyan6: '#13C2C2',
  cyan7: '#08979C',
  cyan8: '#006D75',
  cyan9: '#00474F',
  cyan10: '#002329',
  // Blue
  blue1: '#E6F4FF',
  blue2: '#BAE0FF',
  blue3: '#91CAFF',
  blue4: '#69B1FF',
  blue5: '#4096FF',
  blue6: '#1677FF',
  blue7: '#0958D9',
  blue8: '#003EB3',
  blue9: '#002C8C',
  blue10: '#001D66',
  // Primary
  mmtPrimary1: '#F5FAFF',
  mmtPrimary2: '#EFF8FF',
  mmtPrimary3: '#D1E9FF',
  mmtPrimary4: '#B2DDFF',
  mmtPrimary5: '#84CAFF',
  mmtPrimary6: '#53B1FD',
  mmtPrimary7: '#2E90FA',
  mmtPrimary8: '#1570EF',
  mmtPrimary9: '#175CD3',
  mmtPrimary10: '#1849A9',
  // Purple
  purple1: '#F9F0FF',
  purple2: '#EFDBFF',
  purple3: '#D3ADF7',
  purple4: '#B37FEB',
  purple5: '#9254DE',
  purple6: '#722ED1',
  purple7: '#531DAB',
  purple8: '#391085',
  purple9: '#22075E',
  purple10: '#120338',
  // Magenta
  magenta1: '#FFF0F6',
  magenta2: '#FFD6E7',
  magenta3: '#FFADD2',
  magenta4: '#FF85C0',
  magenta5: '#F759AB',
  magenta6: '#EB2F96',
  magenta7: '#C41D7F',
  magenta8: '#9E1068',
  magenta9: '#780650',
  magenta10: '#520339',
  // Sizes
  sizeUnit: 4,
  size: 16,
  sizeXXS: 4,
  sizeXS: 8,
  sizeSM: 12,
  sizeMD: 20,
  sizeLG: 24,
  sizeXL: 40,
  sizeXXL: 30,
  // Padding
  padding: 16,
  paddingXXS: 4,
  paddingXS: 8,
  paddingSM: 12,
  paddingMD: 20,
  paddingLG: 24,
  paddingXL: 32,
  paddingXXL: 48,
  // Margin
  margin: 16,
  marginXXS: 4,
  marginXS: 8,
  marginSM: 12,
  marginMD: 16,
  marginLG: 24,
  marginXL: 48,
  // Height
  controlHeight: 32,
  controlHeightXS: 16,
  controlHeightSM: 24,
  controlHeightLG: 40,
  // Border Radius
  borderRadius: 6,
  borderRadiusXS: 2,
  borderRadiusSM: 4,
  borderRadiusLG: 8,
  // Font Size
  fontSize: 14,
  fontSizeSM: 12,
  fontSizeLG: 16,
  fontSizeXL: 20,
  fontSizeHeading1: 38,
  fontSizeHeading2: 30,
  fontSizeHeading3: 24,
  fontSizeHeading4: 20,
  fontSizeHeading5: 16
};

var colorsArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var sizeUnitArray = ['XXS', 'XS', 'SM', 'MD', 'LG', 'XL', 'XXL'];
var mapColor = function mapColor(_ref) {
  var theme = _ref.theme,
    key = _ref.key,
    themeKey = _ref.themeKey;
  var _obj = {};
  colorsArray.forEach(function (i) {
    if (theme["".concat(themeKey).concat(i)]) {
      _obj["--".concat(key, "-").concat(i * 10)] = theme["".concat(themeKey).concat(i)];
    }
  });
  return _obj;
};
var mapSizeUnit = function mapSizeUnit(_ref2) {
  var theme = _ref2.theme,
    key = _ref2.key,
    themeKey = _ref2.themeKey;
  var _obj = {};
  sizeUnitArray.forEach(function (i) {
    if (theme["".concat(themeKey).concat(i)]) {
      _obj["--".concat(key, "-").concat(i.toLocaleLowerCase())] = "".concat(theme["".concat(themeKey).concat(i)], "px");
    }
  });
  return _obj;
};
var mapTheme = function mapTheme() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    '--gray-50': theme.gray50,
    '--base-white': theme.white,
    colorPrimary: theme.colorPrimary,
    colorSecondary: theme.colorSecondary,
    '--color-secondary': theme.colorSecondary,
    '--base-gray-10': theme.baseGray10,
    '--base-gray-20': theme.baseGray20,
    '--base-gray-30': theme.baseGray30,
    '--base-gray-40': theme.baseGray40,
    '--base-gray-50': theme.baseGray50,
    '--base-gray-60': theme.baseGray60,
    '--base-gray-70': theme.baseGray70,
    '--base-gray-80': theme.baseGray80,
    '--base-gray-90': theme.baseGray90,
    '--border-color': theme.borderColor,
    '--base-gray-100': theme.baseGray100,
    '--base-gray-110': theme.baseGray110
  }, mapColor({
    theme: theme,
    themeKey: 'red',
    key: 'red'
  })), mapColor({
    theme: theme,
    themeKey: 'blue',
    key: 'blue'
  })), mapColor({
    theme: theme,
    themeKey: 'error',
    key: 'error'
  })), mapColor({
    theme: theme,
    themeKey: 'mmtPrimary',
    key: 'mmt-primary'
  })), mapColor({
    theme: theme,
    themeKey: 'colorPrimary',
    key: 'color-primary'
  })), mapColor({
    theme: theme,
    themeKey: 'colorSecondary',
    key: 'color-secondary'
  })), {}, {
    '--size-unit': "".concat(theme.sizeUnit, "px"),
    '--size': "".concat(theme.size, "px"),
    '--font-size-heading-1': "".concat(theme.fontSizeHeading1, "px"),
    '--font-size-heading-2': "".concat(theme.fontSizeHeading2, "px"),
    '--font-size-heading-3': "".concat(theme.fontSizeHeading3, "px"),
    '--font-size-heading-4': "".concat(theme.fontSizeHeading4, "px"),
    '--font-size-heading-5': "".concat(theme.fontSizeHeading5, "px")
  }, mapSizeUnit({
    theme: theme,
    themeKey: 'size',
    key: 'size'
  })), mapSizeUnit({
    theme: theme,
    themeKey: 'margin',
    key: 'margin'
  })), mapSizeUnit({
    theme: theme,
    themeKey: 'padding',
    key: 'padding'
  })), mapSizeUnit({
    theme: theme,
    themeKey: 'controlHeight',
    key: 'control-height'
  })), mapSizeUnit({
    theme: theme,
    themeKey: 'borderRadius',
    key: 'border-radius'
  })), mapSizeUnit({
    theme: theme,
    themeKey: 'fontSize',
    key: 'font-size'
  }));
};
var applyTheme = function applyTheme() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var themeObject = mapTheme(theme);
  if (!themeObject) return;
  var root = document.documentElement;
  Object.keys(themeObject).forEach(function (property) {
    if (property === 'name') {
      return;
    }
    root.style.setProperty(property, themeObject[property]);
  });
};
var getDefaultTheme = function getDefaultTheme() {
  // const _res = sessionStorage.getItem(KEYS.SESSION_STORAGE);

  // if (_res) {
  //   try {
  //     return JSON.parse(_res);
  //   } catch (err) {
  //     return null;
  //   }
  // }

  return null;
};

var useThemeLayout = function useThemeLayout(_ref) {
  var _ref$callback = _ref.callback,
    callback = _ref$callback === void 0 ? function () {} : _ref$callback;
  var _useState = react.useState(getDefaultTheme()),
    _useState2 = _slicedToArray(_useState, 2),
    theme = _useState2[0],
    setTheme = _useState2[1];
  react.useEffect(function () {
    if (typeof callback === 'function') {
      var getTheme = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var res;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return callback();
              case 3:
                res = _context.sent;
                setTheme(res);
                _context.next = 10;
                break;
              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                setTheme(mmtTheme);
              case 10:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 7]]);
        }));
        return function getTheme() {
          return _ref2.apply(this, arguments);
        };
      }();
      getTheme();
    } else {
      setTheme(mmtTheme);
    }
  }, [callback]);
  react.useEffect(function () {
    if (theme) {
      applyTheme(theme);
      // sessionStorage.setItem(KEYS.SESSION_STORAGE, JSON.stringify(theme));
    }
  }, [theme]);
  return {
    theme: theme
  };
};

function useLinearGradientAreaChart(_ref) {
  var _ref$data = _ref.data,
    data = _ref$data === void 0 ? [] : _ref$data,
    container = _ref.container,
    fill = _ref.fill,
    renderTooltip = _ref.renderTooltip,
    updateTrigger = _ref.updateTrigger;
  var _useState = react.useState(),
    _useState2 = _slicedToArray(_useState, 2),
    mainGraph = _useState2[0],
    setMainGraph = _useState2[1];
  var createChart = function createChart() {
    var chart = mainGraph || new g2.Chart({
      container: container.current,
      autoFit: true
    });
    if (mainGraph) {
      chart.clear();
    }
    chart.data(data);
    chart.area().axis('x', {
      title: false
    }).axis('y', {
      title: false
    }).encode('x', 'date').encode('y', 'Score').style('fill', fill).style('opacity', 0.3);
    chart.line().encode('x', 'date').encode('y', 'Score').style('stroke', fill).style('strokeWidth', 2);
    if (typeof renderTooltip === 'function') {
      chart.interaction('tooltip', {
        render: function render(event, _ref2) {
          var title = _ref2.title,
            items = _ref2.items;
          return renderTooltip(title, items);
        }
      });
    }
    chart.render();
    setMainGraph(chart);
  };
  react.useEffect(function () {
    if (container.current) {
      if (mainGraph) {
        createChart();
      } else {
        createChart();
      }
    }
  }, [data, updateTrigger]);
}

exports.useLinearGradientAreaChart = useLinearGradientAreaChart;
exports.usePagination = usePagination;
exports.useThemeLayout = useThemeLayout;
